import { Branding, DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { WidgetContainer, WidgetView } from 'components/shared';
import { PrimaryButton, SecondaryButton } from 'components/ui';
import React from 'react';
import { ImageAsset } from 'res';
import "./mobile.css";
import './styles.css';

/**
 * @function CreditScoreLeftColWidget
 * @return {React.Component}
 * @exported true
 * @description The Credit Score Widget for the Left Column of the AccountSummaryPage
 */

export default function CreditScoreLeftColWidget(props){
  const date = props.date ?? "Month DD, YYYY";
  const rating = props.rating ?? "Good";
  const alertNum = props.alertNum ?? "9+"
  const loan = props.loan ?? "Rewards Credit Card";

  const dialDataPoint = props.dialDataPoint ?? "Dial";
  const scoreDataPoint = props.scoreDataPoint ?? "Score";
  const updatedDataPoint = props.updatedDataPoint ?? "Updated";
  const alertsDataPoint = props.alertsDataPoint ?? "Alerts";
  const fullReportDataPoint = props.fullReportDataPoint ?? "FullReport";
  const ratingDataPoint = props.ratingDataPoint ? { "data-point": props.ratingDataPoint } : {};

  const scoreChangeNum = props.scoreChangeNum ?? "0";
  const creditUsageNum = props.creditUsageNum ?? "0";

  return(
    <WidgetContainer className="credit-score-left-col-widget">
      <WidgetView text="Credit Score" data-point="Credit_Score_Widget"> 
              <div className="credit-report-container flex-container flex-horizontal">
                <div className="flex-container flex-vertical flex-width credit-score-container">

                  <div className="left-column-container">
                    <div className="text-center">
                      <div className="credit-score-graph-container">
                        <div className="credit-score-image-container text-center">
                          <ImageAsset id="CreditScoreImage" className="credit-score-image" data-point={dialDataPoint} />
                          <span className="credit-score" data-point={scoreDataPoint}>750</span>
                          <div className="credit-score-indicator"></div>
                          <div className="flex-container flex-horizontal align-center credit-range">
                          <span className="flex-width text-left">300</span>
                          <span className="flex-width text-right">850</span>
                        </div>
                        </div>
                      </div>
                      <p><b { ...ratingDataPoint }>Rating: {rating}</b></p>
                      <p className="sub-text">Updated: <span data-point={updatedDataPoint}>{date}</span></p>
                    </div>
                    <div className="flex-container flex-horizontal align-center values-container">
                      <div className="score-change-section flex-width flex-container flex-vertical align-center divider">
                        <div className="score-change-container text-container flex-container flex-horizontal align-center">
                          <span data-point="Score_Change_Num">{ scoreChangeNum }</span>
                        </div>
                        <div className="score-change-text label-container text-center">
                          <span data-point="Score_Change_Label">Score Change</span>
                        </div>
                      </div>
                      <div className="credit-usage-section flex-width flex-container flex-vertical align-center divider">
                        <div className="credit-usage-container flex-container flex-horizontal align-center text-container">
                          <span className="flex-width icon">&#x25BC;</span>
                          <span className="flex-width" data-point="Credit_Usage_Num">{ creditUsageNum }%</span>
                        </div>
                        <div className="credit-usage-text label-container text-center">
                          <span data-point="Credit_Usage_Label">Credit Usage</span>
                        </div>
                      </div>
                      <div className="alerts-section flex-width flex-container flex-vertical text-center align-center">
                        <div className="alert-container text-center text-container">
                          <span data-point="Alerts_Num">{alertNum}</span>
                        </div>
                        <div className="alert-text label-container text-center">
                          <span data-point={alertsDataPoint}>New Alerts</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="button-container text-center">
                  <Branding id="cs21_courseID_abi22" exp={val => val === null}>
                    <DisabledPrompt>
                      <PrimaryButton text="Show Full Report" data-point={fullReportDataPoint} />
                    </DisabledPrompt>
                    </Branding>
                    <Branding id="cs21_courseID_abi22" exp={val => val !== null}>   
                    <Link to="/creditScore">
                    <PrimaryButton text="Show Full Report" data-point={fullReportDataPoint} /> 
                    </Link>                              
                    </Branding> 
                  </div>
                </div>
                <div className="flex-width recommended-container flex-container flex-vertical text-center">
                  <div className="top-container recommended-item">
                    <span className="section-label recommended-for-you-header">Recommended for you</span>
                    <div className="indicator-container flex-container flex-horizontal all-center show-on-desktop">
                      <DisabledPrompt>
                        <div className="circle-indicator selected clickable"></div>
                      </DisabledPrompt>
                      <DisabledPrompt>
                        <div className="circle-indicator clickable"></div>
                      </DisabledPrompt>
                      <DisabledPrompt>
                        <div className="circle-indicator clickable"></div>
                      </DisabledPrompt>
                    </div>
                  </div>
                  
                  <div className="recommended-offer-container recommended-item flex-container flex-vertical">
                    <b className="sub-text">Transfer your credit card balances!</b>
                    <ImageAsset id="CreditCardStackedIcon" className="credit-card-icon" />
                    <b className="sub-text">{loan}</b>
                  </div>
                  <div className="learn-more-button-container button-container show-on-desktop justify-self-end">
                    <DisabledPrompt>
                      <SecondaryButton text="Learn More" />
                    </DisabledPrompt>
                  </div>
                  <div className="learn-more-container recommended-item show-on-mobile">
                    <DisabledPrompt>
                      <Link>Learn more</Link>
                    </DisabledPrompt>
                    <div className="indicator-container flex-container flex-horizontal all-center">
                      <DisabledPrompt>
                        <div className="circle-indicator selected clickable"></div>
                      </DisabledPrompt>
                      <DisabledPrompt>
                        <div className="circle-indicator clickable"></div>
                      </DisabledPrompt>
                      <DisabledPrompt>
                        <div className="circle-indicator clickable"></div>
                      </DisabledPrompt>
                    </div>
                  </div>
                </div>
                
              </div>
            </WidgetView>
    </WidgetContainer>
  );
}